import { render } from "./ProfileHome.vue?vue&type=template&id=0533d5ea&scoped=true"
import script from "./ProfileHome.vue?vue&type=script&lang=js"
export * from "./ProfileHome.vue?vue&type=script&lang=js"

import "./ProfileHome.vue?vue&type=style&index=0&id=0533d5ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0533d5ea"]])

export default __exports__